import {
	BaseQueryFn,
	FetchArgs,
	fetchBaseQuery,
	FetchBaseQueryError,
	FetchBaseQueryMeta,
} from '@reduxjs/toolkit/query/react';
import { isTMA, retrieveRawInitData } from '@telegram-apps/bridge';

import { notification } from 'antd';

import { ERRORS } from 'shared/consts';
import { EErrorCodes, IBadRequestData } from 'shared/typings';

export const baseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta> = async (
	args,
	api,
	extraOptions,
) => {
	const result = await fetchBaseQuery({
		baseUrl: '/',
		prepareHeaders: (headers) => {
			headers.append(
				'Authorization',
				`tma user=%7B%22id%22%3A5002823799%2C%22first_name%22%3A%22Vadzim%22%2C%22last_name%22%3A%22Liashkevich%22%2C%22username%22%3A%22lesh1j%22%2C%22language_code%22%3A%22ru%22%2C%22allows_write_to_pm%22%3Atrue%2C%22photo_url%22%3A%22https%3A%5C%2F%5C%2Fa-ttgme.stel.com%5C%2Fi%5C%2Fuserpic%5C%2F320%5C%2FakYkBfKGOSb5vmBMmmeOBRj29nE61-7NCSbk2Q321FDzjsS6kJdw-SuH8N2_uLxp.svg%22%7D&chat_instance=426742912542743483&chat_type=sender&auth_date=1760551440&signature=oR1pfUi219IabPJH8c3vCDrC1WLRLb2GoosgX6sy3Ay7U8ab3c5reQAxPOE2H9sw1rXCH0idwRTZESWpcAOIBQ&hash=f0a964837e9e940505f3a88a0991f2fbbc92c1c50a808b20497b3028846d08f8`,
			);

			if (isTMA()) {
				const initDataRaw = retrieveRawInitData();
				headers.append('Authorization', `tma ${initDataRaw}`);
			}

			return headers;
		},
		paramsSerializer: (params) => {
			const searchParams = new URLSearchParams();

			Object.entries(params).forEach(([key, value]) => {
				if (Array.isArray(value)) {
					value.forEach((v) => searchParams.append(key, v));
				} else if (value !== null && value !== undefined) {
					searchParams.append(key, value.toString());
				}
			});

			return searchParams.toString();
		},
	})(args, api, extraOptions);

	const statusCode = result.meta?.response?.status;

	if (statusCode === EErrorCodes.UNAUTHORIZED || statusCode === EErrorCodes.FORBIDDEN) {
		//window.location.replace(`/${EMainRoutes.ACCOUNT}/${EMainRoutes.LOG_IN}`);
	}

	if (
		statusCode === EErrorCodes.BAD_GATEWAY ||
		statusCode === EErrorCodes.INTERNAL_SERVER_ERRROR ||
		statusCode === EErrorCodes.TOO_MANY_REQUESTS ||
		statusCode === EErrorCodes.PAGE_NOT_FOUND
	) {
		const text = result.meta?.response?.statusText;

		notification.error({
			message: `${statusCode} - ${text}`,
			placement: 'bottom',
			showProgress: true,
			pauseOnHover: true,
		});
	}

	if (statusCode === EErrorCodes.BAD_REQUEST) {
		const data = Array.isArray(result.error?.data) ? result.error?.data : [result.error?.data || {}];

		data.forEach((item) => {
			let errorText = '';

			if (typeof item === 'string') {
				errorText = ERRORS[item]?.() || item;

				errorText &&
					notification.error({
						message: errorText,
						placement: 'bottom',
						showProgress: true,
						pauseOnHover: true,
					});
			}

			if (typeof item === 'object') {
				Object.values(item).forEach((value) => {
					if (Array.isArray(value)) {
						value.forEach((error) => {
							if (typeof error === 'string') {
								errorText = ERRORS[error]?.() || error;
							}

							if (typeof error === 'object' && 'code' in error && 'detail' in error && 'additional_data' in error) {
								const errorObject = error as IBadRequestData;
								errorText = ERRORS[errorObject.code]?.(error.additional_data) || errorObject.detail;
							}

							errorText &&
								notification.error({
									message: errorText,
									placement: 'bottom',
									showProgress: true,
									pauseOnHover: true,
								});
						});
					}
				});
			}
		});
	}

	return result;
};
